(function () {
  if (window.springMulberryTestimonialsInitialized) return;
  window.springMulberryTestimonialsInitialized = true;

  const instances = new WeakMap();

  function initialize(carousel) {
    if (instances.has(carousel) || typeof window.Swiper !== "function") return;

    const slider = carousel.querySelector(".swiper-testimonial");
    if (!slider) return;

    const autoplay = carousel.dataset.autoplay === "true";
    const liveRegion = carousel.querySelector(".swiper-wrapper");
    const toggle = carousel.querySelector(".testimonial-rotation-toggle");
    const pauseIcon = carousel.querySelector(".testimonial-rotation-toggle__pause");
    const playIcon = carousel.querySelector(".testimonial-rotation-toggle__play");
    const swiper = new window.Swiper(slider, {
      autoplay: {
        enabled: autoplay,
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      slidesPerView: 1,
      effect: "fade",
      fadeEffect: { crossFade: true },
      loop: slider.querySelectorAll(".swiper-slide").length > 1,
      navigation: {
        nextEl: carousel.querySelector(".swiper-button-next-testimonials"),
        prevEl: carousel.querySelector(".swiper-button-prev-testimonials"),
      },
      pagination: {
        el: carousel.querySelector(".swiper-pagination-testimonials"),
      },
    });

    function updateSlideVisibility() {
      carousel.querySelectorAll(".swiper-slide").forEach(function (slide) {
        const active = slide.classList.contains("swiper-slide-active");
        slide.setAttribute("aria-hidden", String(!active));
        slide.toggleAttribute("inert", !active);
      });
    }

    function updateRotationState() {
      const rotating = swiper.autoplay.running;
      if (liveRegion) liveRegion.setAttribute("aria-live", rotating ? "off" : "polite");
      if (toggle) {
        toggle.setAttribute("aria-label", rotating ? carousel.dataset.stopLabel : carousel.dataset.startLabel);
      }
      if (pauseIcon) pauseIcon.classList.toggle("hidden", !rotating);
      if (playIcon) playIcon.classList.toggle("hidden", rotating);
    }

    function toggleRotation() {
      if (swiper.autoplay.running) {
        swiper.autoplay.stop();
      } else {
        swiper.autoplay.start();
      }
    }

    function stopOnFocus(event) {
      if (event.target.closest(".testimonial-rotation-toggle")) return;
      swiper.autoplay.stop();
    }

    if (toggle) toggle.addEventListener("click", toggleRotation);
    carousel.addEventListener("focusin", stopOnFocus);
    swiper.on("slideChangeTransitionEnd", updateSlideVisibility);
    swiper.on("autoplayStart", updateRotationState);
    swiper.on("autoplayStop", updateRotationState);
    updateSlideVisibility();
    updateRotationState();

    instances.set(carousel, function () {
      if (toggle) toggle.removeEventListener("click", toggleRotation);
      carousel.removeEventListener("focusin", stopOnFocus);
      swiper.destroy(true, true);
      instances.delete(carousel);
    });
  }

  function initializeWithin(root) {
    root.querySelectorAll("[data-testimonial-carousel]").forEach(initialize);
  }

  initializeWithin(document);

  document.addEventListener("shopify:section:load", function (event) {
    initializeWithin(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    event.target.querySelectorAll("[data-testimonial-carousel]").forEach(function (carousel) {
      const cleanup = instances.get(carousel);
      if (cleanup) cleanup();
    });
  });
})();
